import { searchToObject } from "fe2/utils/index";
import {shouldHideTasksNav} from 'helpers/clanTasks';
import {ClanRec2IsEnabled, darwinIsEnabled} from 'helpers/common';
import { t } from "helpers/localization";
import { getItemObjectFromLocalStorage, setItemObjectToLocalStorage } from "helpers/localStorage";
import { getSearchClassForBody } from "helpers/search";
import { lastSeason } from "helpers/seasons";
import isEmpty from "lodash/isEmpty";
import { hasPermission, permissions } from "roles";
import settings from "settings";
import { setSelectedTab as setSelectedTabClanBattles } from "./Actions/ActionClanBattles";
import { setSelectedTab as setSelectedTabClanWars } from "./Actions/ActionClanWars";
import { setSelectedTab as setSelectedTabTreasury } from './Actions/ActionTreasury';
import {getLastRegularSeason, getLastBrawlSeason} from './helpers/ladder'
import { store } from "./app";
import {CLAN_TASK_NAMES} from "~/Components/ViewClanTasks/constants";
import { isLoggedIn } from "./utils/auth"

const searchParams = searchToObject();

const IS_DEV_MODE = Object.keys(searchParams).indexOf('devmode') !== -1 && searchParams.devmode !== false;

const checkTreasury = account => {
  let isTreasuryBuilt = false;

  if (account.supplyBuildings && account.supplyBuildings.length) {
    account.supplyBuildings.forEach(item => {
      if (item && item.type === 'treasury') {
        if (item.level > 0) {
          isTreasuryBuilt = true;
        }
      }
    });
  }

  return isTreasuryBuilt;
};

export default [{
  path: 'profile',
  title: () => t('Военная база'),
  badge: 'profile',
  componentName: 'ContainerClanProfile',
  bodyClass: () => settings.supply.isEnabled ? 'navalBase' : 'profile',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId) {
      replace({ pathname: `${root}search` });
    }
  },
  display: account => !!account.clanId
}, {
  path: 'tasks',
  title: () => t('Задачи клана'),
  badge: 'tasks',
  componentName: 'ContainerClanTasks',
  bodyClass: () => 'tasks',
  beforeEnter: (replace, root, account, state) => {
    const sawClanTasks = getItemObjectFromLocalStorage('sawClanTasks')
    if (!darwinIsEnabled || !account.clanId || shouldHideTasksNav(state.ReducerClanTasks.tasks, CLAN_TASK_NAMES.length)) {
        replace({ pathname: `${root}` })
    } else if (!sawClanTasks[account.id]) {
        sawClanTasks[account.id] = true
        setItemObjectToLocalStorage('sawClanTasks', sawClanTasks)
    }
  },
  display: (account, state) => darwinIsEnabled && !!account.clanId && !shouldHideTasksNav(state.ReducerClanTasks.tasks, CLAN_TASK_NAMES.length),
}, {
  path: 'clan-profile/:clanId',
  componentName: 'ContainerClanProfile',
  bodyClass: () => settings.supply.isEnabled ? 'navalBase' : 'profile',
  display: () => false
}, {
  path: 'members',
  title: () => t('Состав клана'),
  badge: 'members',
  componentName: 'MembersRoute',
  bodyClass: () => 'members',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId) {
      replace({ pathname: `${root}search` });
    }
  },
  display: account => !!account.clanId
}, {
  path: 'clan-profile/:clanId/members',
  componentName: 'MembersRoute',
  bodyClass: () => 'members',
  display: () => false
}, {
  path: 'search',
  title: () => t('Поиск кланов'),
  badge: 'search',
  componentName: 'Search',
  bodyClass: state => getSearchClassForBody(state.currentAccount.clanId, state.searchResult.isFetchedBefore)
}, 
{
  path: 'new-recommendations',
title: () => t('Рекомендации'),
  badge: 'new-recommendations',
  componentName: 'ContainerRecommendations',
  bodyClass: () => 'new-recommendations',
  beforeEnter: (replace, root, account) => {
      if (account.clanId && searchParams.utm_source=="global-nav"){
        replace({ pathname: `${root}` })
      }

      let sawClanRec2 = getItemObjectFromLocalStorage('sawClanRec2')

      if (!ClanRec2IsEnabled ||
          (account.clanId && !settings.clanrec2.showRecommendationsForClansMembers)) {
          replace({ pathname: `${root}` })
      } else if (!sawClanRec2[account.id]) {
          sawClanRec2[account.id] = true
          setItemObjectToLocalStorage('sawClanRec2', sawClanRec2)
      }
  },
  display: (account) => ClanRec2IsEnabled &&
      (!account.clanId || settings.clanrec2.showRecommendationsForClansMembers),
},
{
  path: 'new-recommendations/:purpose/:currentSlide',
  title: () => t('Рекомендации'),
  badge: 'new-recommendations',
  componentName: 'ContainerRecommendations',
  beforeEnter: (replace, root, account) => {
      if (!ClanRec2IsEnabled || (account.clanId && !settings.clanrec2.showRecommendationsForClansMembers))
          replace({ pathname: `${root}` })
  },
  bodyClass: () => 'new-recommendations',
  display: () => false,
},
{
  path: 'treasury',
  componentName: 'ContainerTreasury',
  bodyClass: () => 'treasury',
  title: () => t('Казна клана'),
  beforeEnter: (replace, root, account) => {

    if (IS_DEV_MODE) {
      return;
    }

    const isTreasuryBuilt = checkTreasury(account);

    if (!account.clanId || !isTreasuryBuilt) {
      replace({ pathname: `${root}profile` });
    }
  },
  display: account => {

    if (IS_DEV_MODE) {
      return true;
    }

    const isTreasuryBuilt = checkTreasury(account);

    return !!account.clanId && isTreasuryBuilt;
  }
},
{
  path: 'treasury/expenses',
  componentName: 'ContainerTreasury',
  bodyClass: () => 'treasury',
  title: () => t('Казна клана - Расходы'),
  beforeEnter: (replace, root, account) => {
    const isTreasuryBuilt = checkTreasury(account)
    if (!account.clanId || !isTreasuryBuilt) {
      replace({ pathname: `${root}profile` })
    }
    store.dispatch(setSelectedTabTreasury(0))
  },
  display: (account) => {
    return false
  },
},
{
  path: 'treasury/income',
  componentName: 'ContainerTreasury',
  bodyClass: () => 'treasury',
  title: () => t('Казна клана - Доходы'),
  beforeEnter: (replace, root, account) => {
    const isTreasuryBuilt = checkTreasury(account)
    if (!account.clanId || !isTreasuryBuilt) {
      replace({ pathname: `${root}profile` })
    }
    store.dispatch(setSelectedTabTreasury(1))
  },
  display: (account) => {
    return false
  },
},
{
  path: 'treasury/distribution',
  componentName: 'ContainerTreasury',
  bodyClass: () => 'treasury',
  title: () => t('Казна клана - Распределение'),
  beforeEnter: (replace, root, account) => {
    const isTreasuryBuilt = checkTreasury(account)
    if (!account.clanId || !isTreasuryBuilt) {
      replace({ pathname: `${root}profile` })
    }
    store.dispatch(setSelectedTabTreasury(2))
  },
  display: (account) => {
    return false
  },
},
{
  path: 'treasury/regularRewards',
  componentName: 'ContainerTreasury',
  bodyClass: () => 'treasury',
  title: () => t('Казна клана - Регулярные награды'),
  beforeEnter: (replace, root, account) => {
    const isTreasuryBuilt = checkTreasury(account)
    if (!account.clanId || !isTreasuryBuilt) {
      replace({ pathname: `${root}profile` })
    }
    store.dispatch(setSelectedTabTreasury(3))
  },
  display: (account) => {
    return false
  },
},
{
  path: 'requests',
  title: () => t('Запросы'),
  badge: 'requests',
  componentName: 'Requests',
  bodyClass: () => 'requests',
  beforeEnter: (replace, root, account) => {
    if (account.clanId && !hasPermission(account.roleName, permissions.HANDLE_INVITES)) {
      replace({ pathname: `${root}profile` });
    }
  },
  display: account => (isLoggedIn() && !account.clanId) || hasPermission(account.roleName, permissions.HANDLE_INVITES)
}, {
  path: 'create',
  title: () => t('Создать клан'),
  badge: 'create',
  componentName: 'ClanCreate',
  bodyClass: () => 'create',
  beforeEnter: (replace, root, account) => {
    if (account.clanId) {
      replace({ pathname: `${root}profile` });
    }
  },
  display: account => (isLoggedIn() && !account.clanId)
}, {
  separator: true,
  path: 'clan-wars',
  title: () => t('Морское сражение'),
  badge: 'profile',
  componentName: 'ClanWars',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!(!!account.id && settings.cwars.isEnabled)) {
      replace({ pathname: `${root}search` });
    } else {
      replace({ pathname: `${root}clan-wars/war` });
    }
  },
  display: account => {
    return !!account.id && settings.cwars.isEnabled;
  }
}, {
  separator: true,
  path: 'clan-wars/war',
  title: () => t('Морское сражение - Война'),
  badge: 'profile',
  componentName: 'ClanWars',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!(!!account.id && settings.cwars.isEnabled)) {
      replace({ pathname: `${root}search` });
    }
    store.dispatch(setSelectedTabClanWars(0));
  },
  display: () => {
    return false;
  }
}, {
  separator: true,
  path: 'clan-wars/rating',
  title: () => t('Морское сражение - Рейтинг'),
  badge: 'profile',
  componentName: 'ClanWars',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!(!!account.id && settings.cwars.isEnabled)) {
      replace({ pathname: `${root}search` });
    }
    store.dispatch(setSelectedTabClanWars(1));
  },
  display: () => {
    return false;
  }
}, {
  separator: true,
  path: 'clan-wars/rules',
  title: () => t('Морское сражение - Правила'),
  badge: 'profile',
  componentName: 'ClanWars',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!(!!account.id && settings.cwars.isEnabled)) {
      replace({ pathname: `${root}search` });
    }
    store.dispatch(setSelectedTabClanWars(2));
  },
  display: () => {
    return false;
  }
}, {
  path: 'clan-battles',
  title: () => t('Клановые бои'),
  badge: 'clan-battles',
  componentName: 'ContainerClanBattles',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId && isEmpty(lastSeason)) {
      replace({ pathname: root });
    } else {
      replace({ pathname: `${root}clan-battles/history` });
    }
  },
  display: () => {
    return getLastRegularSeason() || getLastBrawlSeason();
  }
}, {
  path: 'clan-battles/history',
  title: () => t('Клановые бои - История'),
  badge: 'clan-battles',
  componentName: 'ContainerClanBattles',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId && isEmpty(lastSeason)) {
      replace({ pathname: root });
    }
    store.dispatch(setSelectedTabClanBattles(0));
  },
  display: () => {
    return false;
  }
}, {
  path: 'clan-battles/rating',
  title: () => t('Клановые бои - Рейтинги'),
  badge: 'clan-battles',
  componentName: 'ContainerClanBattles',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId && isEmpty(lastSeason)) {
      replace({ pathname: root });
    }
    store.dispatch(setSelectedTabClanBattles(1));
  },
  display: () => {
    return false;
  }
}, {
  path: 'clan-battles/rating/:seasonType/:season/:realm',
  title: () => t('Клановые бои - Рейтинги'),
  badge: 'clan-battles',
  componentName: 'ContainerClanBattles',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId && isEmpty(lastSeason)) {
      replace({ pathname: root });
    }
    store.dispatch(setSelectedTabClanBattles(1));
  },
  display: () => {
    return false;
  }
}, {
  path: 'clan-battles/rules',
  title: () => t('Клановые бои - Правила'),
  badge: 'clan-battles',
  componentName: 'ContainerClanBattles',
  bodyClass: () => 'clan-wars',
  beforeEnter: (replace, root, account) => {
    if (!account.clanId && isEmpty(lastSeason)) {
      replace({ pathname: root });
    }
    store.dispatch(setSelectedTabClanBattles(2));
  },
  display: () => {
    return false;
  }
}];